export type ThemePreference = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'kairos.theme';

export function loadThemePreference(): ThemePreference {
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === 'light' || v === 'dark' || v === 'system') return v;
  return 'system';
}

export function saveThemePreference(t: ThemePreference): void {
  localStorage.setItem(STORAGE_KEY, t);
}

export function applyThemePreference(t: ThemePreference): void {
  const root = document.documentElement;
  if (t === 'system') {
    delete root.dataset.theme;
  } else {
    root.dataset.theme = t;
  }
}
